import { render, staticRenderFns } from "./Stories.vue?vue&type=template&id=3856e045&scoped=true"
import script from "./Stories.vue?vue&type=script&lang=js"
export * from "./Stories.vue?vue&type=script&lang=js"
import style0 from "./Stories.vue?vue&type=style&index=0&id=3856e045&prod&lang=scss&scoped=true"
import style1 from "./Stories.vue?vue&type=style&index=1&id=3856e045&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3856e045",
  null
  
)

export default component.exports